/* «Баланс» на React. Узлы страницы — те же, что собирала одна строка прототипа: заголовок, тарифы,
   подпись подписчика, «Что входит», сроки, подарок, строки подписчика, скидка друга, промокод, кнопка.
   Внутрь блоков кладётся готовая разметка: дальше её правят pop, swap и tick по id, и React её не перерисовывает.
   Обёртки .lx вокруг блоков нет: у колонки .stp-in правило на прямых детей (flex: none), лишняя обёртка сдвинула бы кадр.
   Листы остаются разметкой BotCore и стоят рядом со страницей, чтобы не ехать вместе с прокруткой. */
import { useLayoutEffect, useRef, useState } from 'react';
import { LegacyHtml } from '../../ui/LegacyHtml';
import { balanceApi } from './module';
import { uiText, useAccountLocale } from '../../i18n';
/** Куски первого кадра: их отдаёт prepare() после флага оплаты */
export interface BalanceView {
  buy: boolean;
  title: string;
  plans: string;
  me: string;
  inc: string;
  perStyle: string;
  per: string;
  gift: string;
  rows: string;
  wait: string;
  promo: string;
  sub: string;
  sheets: string;
}

export interface BalanceApi {
  prepare: () => BalanceView;
  attach: () => void;
}

/** Срок: цвета тарифа (--s1…--s3) той же строкой, что пишет perSync, иначе он перезапишет атрибут */
function Periods({ html, style }: { html: string; style: string }) {
  const ref = useRef<HTMLDivElement>(null);
  /* подпись группы — на языке профиля; разметку сроков при смене языка перерисовывает движок (relocale) */
  useAccountLocale();
  useLayoutEffect(() => {
    const el = ref.current;
    if (el && el.getAttribute('style') !== style) el.setAttribute('style', style);
  }, [style]);
  return (
    <div ref={ref} className="bl-pers" id="blPers" role="radiogroup" aria-label={uiText('Срок')} dangerouslySetInnerHTML={{ __html: html }} />
  );
}

export function Balance() {
  const api = balanceApi();
  const [m] = useState(() => api.prepare());
  useLayoutEffect(() => {
    api.attach();
  }, [api]);
  return (
    <>
      <div className={'pg stp' + (m.buy ? ' bl-hs' : '')} id="balance">
        <div className="stp-in">
          <h1 className="bl-h" id="blH" dangerouslySetInnerHTML={{ __html: m.title }} />
          <div className="bl-top bc-sticky" dangerouslySetInnerHTML={{ __html: m.plans }} />
          <div className="bl-mew" id="blMe" dangerouslySetInnerHTML={{ __html: m.me }} />
          <section className="bl-inc" id="blInc" aria-labelledby="blIncH" dangerouslySetInnerHTML={{ __html: m.inc }} />
          <Periods html={m.per} style={m.perStyle} />
          <div className="bl-more">
            <button className="bl-gr" type="button" data-bl-gift="" aria-haspopup="dialog" hidden={!m.gift} dangerouslySetInnerHTML={{ __html: m.gift }} />
            <div className="bl-pkw" id="blPkW" dangerouslySetInnerHTML={{ __html: m.rows }} />
          </div>
          <div className="bl-wait" id="blWait" dangerouslySetInnerHTML={{ __html: m.wait }} />
          <div className="bl-promo" id="blPromo" dangerouslySetInnerHTML={{ __html: m.promo }} />
          <div className="bl-subw" id="blSubW" dangerouslySetInnerHTML={{ __html: m.sub }} />
        </div>
      </div>
      <LegacyHtml html={() => m.sheets} />
    </>
  );
}
